PluginRegistry.add('route', {
    'url': '/',
    'module': 'graphdb.workbench',
    'chunk': 'home',
    'path': 'controllers',
    'controller': 'homeCtrl',
    'templateUrl': 'pages/home.html',
});

PluginRegistry.add('main.menu', {
        items: [
            {
                label: 'Setup',
                labelKey: 'menu.setup.label',
                href: '#',
                order: 5,
                role: 'IS_AUTHENTICATED_FULLY',
                icon: "ri-settings-3-line",
                guideSelector: 'menu-setup',
                testSelector: 'menu-setup',
                children: [],
            },
            {
                label: 'Monitor',
                labelKey: 'menu.monitor.label',
                href: '#',
                order: 3,
                // Changed to role user as now users can monitor their own queries
                role: 'ROLE_USER',
                icon: 'ri-heart-pulse-line',
                guideSelector: 'menu-monitor',
                testSelector: 'menu-monitoring',
                children: [],
            },
            {
                label: 'Lab',
                labelKey: 'menu.lab.label',
                href: '#',
                order: 6,
                role: 'ROLE_USER',
                icon: "ri-flask-line",
                guideSelector: 'menu-lab',
                testSelector: 'menu-lab',
                children: [],
            },
        ],
    },
);
PluginRegistry.add('main.menu', {
        disabled: true,
        items: [
            {
                label: 'New YASGUI',
                labelKey: 'New YASGUI',
                href: 'sparql-new',
                order: 1.9,
                role: 'IS_AUTHENTICATED_FULLY',
                icon: "icon-sparql",
                guideSelector: 'menu-new-yasgui',
                children: [],
            },
        ],
    },
);
